module.exports = __webpack_public_path__ + "static/media/loading.f2452585.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/loading.gif
// module id = 143
// module chunks = 0